import {
  Avatar,
  Button,
  Container,
  Group,
  Stack,
  Table,
  Title,
} from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Board } from "../../common/boards/board.schema";
import { Event } from "../../common/events/event.schema";
import PrintFooter from "../print/PrintFooter";
import { ResultRow } from "./Results";

const PrintResults = ({
  disabled,
  event,
  board,
  debug,
  showClubs,
  showFlags,
}: {
  disabled?: boolean;
  debug?: boolean;
  event: Event;
  board: Board;
  showClubs?: boolean;
  showFlags?: boolean;
}) => {
  const componentRef = useRef<any>();
  const image = event.image || board.image;
  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Button
            leftSection={<IconPrinter size={15} />}
            variant="subtle"
            disabled={disabled}
            size="xs"
          >
            Print results
          </Button>
        )}
        content={() => componentRef.current || null}
      />
      <div style={{ display: debug ? "block" : "none" }}>
        <Container>
          <Stack
            align="center"
            ref={componentRef}
            style={{ backgroundColor: "white", color: "black" }}
            py={20}
            px={20}
            gap={60}
          >
            <Stack align="center">
              <Group>
                {image && <Avatar src={image} />}
                <Title ta="center">{board.name}</Title>
              </Group>
              <Title order={2} ta="center">
                {event.name}
              </Title>
              <Title order={3} ta="center">
                Event results
              </Title>
            </Stack>
            <Table>
              <Table.Tbody>
                {event.results &&
                  event.results.map((r, index) => {
                    const retired = event.withdrawals.indexOf(r) > -1;
                    return (
                      <ResultRow
                        key={index}
                        position={index + 1}
                        event={event}
                        memberId={r}
                        retired={retired}
                        showClub={showClubs}
                        showFlag={showFlags}
                      />
                    );
                  })}
              </Table.Tbody>
            </Table>
            <PrintFooter />
          </Stack>
        </Container>
      </div>
    </>
  );
};
export default PrintResults;
